import { render, staticRenderFns } from "./RouterLinkCard.vue?vue&type=template&id=1b61a8c8&"
import script from "./RouterLinkCard.vue?vue&type=script&lang=js&"
export * from "./RouterLinkCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports